import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  attrs: {
    addressLine1: {
      key: 'address_line_1'
    },
    // street 1
    addressLine2: {
      key: 'address_line_2'
    },
    // street 2
    addressLine3: {
      key: 'address_line_3'
    },
    addressLine4: {
      key: 'address_line_4'
    },
    addressLine5: {
      key: 'address_line_5'
    },
    sublocality1: {
      key: 'sublocality_1'
    },
    sublocality2: {
      key: 'sublocality_2'
    },
    sublocality3: {
      key: 'sublocality_3'
    },
    sublocality4: {
      key: 'sublocality_4'
    },
    sublocality5: {
      key: 'sublocality_5'
    },
    administrativeDistrictLevel1: {
      key: 'administrative_district_level_1'
    },
    // state
    administrativeDistrictLevel2: {
      key: 'administrative_district_level_2'
    },
    administrativeDistrictLevel3: {
      key: 'administrative_district_level_3'
    }
  }
});